export type ActionStatus = 'pending' | 'in progress' | 'done' | 'canceled'

export class ActionInput {
  id: string;
  title: string;
  description: string;
  status: 'pending' | 'in progress' | 'done' | 'canceled' | '' = '';
  responsibleId: string = '';
  startDate: Date;
  endDate: string;

  idea: {
    id: string;
    title: string;
    code: string;
  }
}

export class UpdateActionInput {
  title?: string;
  description?: string;
  status?: 'pending' | 'in progress' | 'done' | 'canceled';
  responsibleId?: string;
  startDate?: Date;
  endDate?: Date;
}
